import { createContext, type PropsWithChildren, useContext } from "react";

import type { CptStudyPlanPreset } from "~/lib/cpt-study-plan-preset";

export type WizardMode = "live" | "deferred";

interface WizardModeContextValue {
	mode: WizardMode;
	// In deferred (overlay) mode, returns from the first step back to the
	// surrounding launcher (e.g. the WelcomeModal options list).
	onExit?: () => void;
	preset?: CptStudyPlanPreset | null;
}

const WizardModeContext = createContext<WizardModeContextValue>({
	mode: "live",
});

export const WizardModeProvider = ({
	mode,
	onExit,
	preset,
	children,
}: PropsWithChildren<{
	mode: WizardMode;
	onExit?: () => void;
	preset?: CptStudyPlanPreset | null;
}>) => (
	<WizardModeContext.Provider value={{ mode, onExit, preset }}>
		{children}
	</WizardModeContext.Provider>
);

export const useWizardMode = () => useContext(WizardModeContext);
